import { useEffect, useMemo, useState } from 'react';

import { ia } from 'lib/helpers/utility';

const useBreadcrumb = (s, initialStep = 0) => {
  const [steps, setSteps] = useState(s ? (ia(s) ? s : [s]) : []);
  const [step, setStep] = useState(initialStep);

  useEffect(() => {
    setSteps(s ? (ia(s) ? s : [s]) : []);
  }, [s]);

  const currentStep = useMemo(() => steps[step]?.name, [step]);
  const current = useMemo(() => steps[step], [step, steps]);

  const goBack = (withoutTrim = false) => {
    setStep((prev) => {
      if (prev === 0) return prev;
      if (withoutTrim) return prev - 1;
      setSteps((prevSteps) => prevSteps.slice(0, prev));
      return prev - 1;
    });
  };

  const goNext = () => {
    setStep((prev) => (prev === steps.length - 1 ? prev : prev + 1));
  };

  const setStepWithTrim = (step) => {
    if (step < 0 || step >= steps.length) {
      console.warn(`setStepWithTrim: step ${step} is out of bounds [0, ${steps.length - 1}]`);
      return;
    }
    setSteps((prevSteps) => prevSteps.slice(0, step + 1));
    setStep(step);
  };

  const goToStep = (stepName) => {
    const index = steps.findIndex((step) => step.name === stepName);
    if (index !== -1) setStep(index);
  };

  const push = (newStep) => {
    const existingIndex = steps.findIndex((s) => s.name === newStep.name);
    if (existingIndex !== -1) {
      // Step already exists: jump to that step
      const trimmedSteps = steps.slice(0, existingIndex + 1);
      setSteps([...trimmedSteps]);
      setStep(existingIndex);
    } else {
      // Add the new step and trim forward steps
      const trimmedSteps = steps.slice(0, step + 1);
      setSteps([...trimmedSteps, newStep]);
      setStep(trimmedSteps.length);
    }
  };

  return {
    steps,
    step,
    setStep,
    goBack,
    push,
    currentStep,
    setSteps,
    goToStep,
    current,
    goNext,
    setStepWithTrim
  };
};

export default useBreadcrumb;
